/**
 * 睡眠レポートの表示用フォーマット
 */

import { formatDurationMinutes } from '@/lib/activity-format-utils'
import { parseUtcDate } from '@/lib/date-utils'

export const formatMinutes = (minutes: number | null | undefined): string =>
  minutes === null || minutes === undefined ? '--' : formatDurationMinutes(minutes)

const jstParts = (iso: string) => {
  const parts = new Intl.DateTimeFormat('ja-JP', {
    timeZone: 'Asia/Tokyo',
    month: 'numeric',
    day: 'numeric',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(parseUtcDate(iso))
  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? ''
  return {
    date: `${get('month')}/${get('day')}`,
    weekday: get('weekday'),
    time: `${get('hour')}:${get('minute')}`,
  }
}

/** 「10/2(木) 14:30〜17:37」。日をまたぐ場合は終了側にも日付を付ける */
export const formatSleepRange = (start: string, end: string): string => {
  const s = jstParts(start)
  const e = jstParts(end)
  const endLabel = s.date === e.date ? e.time : `${e.date} ${e.time}`
  return `${s.date}(${s.weekday}) ${s.time}〜${endLabel}`
}

export const formatJstTime = (iso: string): string => jstParts(iso).time

export const formatJstDate = (iso: string): string => {
  const p = jstParts(iso)
  return `${p.date}(${p.weekday})`
}

/** 起床日（YYYY-MM-DD）を「10/2(木)」にする */
export const formatDay = (day: string): string => formatJstDate(`${day}T00:00:00+09:00`)

/** 今日の JST の日付（YYYY-MM-DD） */
export const todayJstDate = (): string => new Date(Date.now() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10)

/** 普段との差を「+12」「-3.5」のように出す */
export const formatSigned = (value: number, digits = 0): string => {
  const rounded = Number(value.toFixed(digits))
  return `${rounded > 0 ? '+' : ''}${rounded}`
}

export const SLEEP_KIND_LABEL = new Map<string, string>([
  ['main', '睡眠'],
  ['nap', '昼寝'],
])

/** Garmin の評価（EXCELLENT など）の日本語表記 */
export const QUALIFIER_LABEL = new Map<string, string>([
  ['EXCELLENT', '非常に良い'],
  ['GOOD', '良い'],
  ['FAIR', 'まずまず'],
  ['POOR', '悪い'],
  ['INVALID', '判定なし'],
])

export const SUB_QUALIFIER_LABEL = new Map<string, string>([
  ['totalDuration', '睡眠時間'],
  ['stress', 'ストレス'],
  ['awakeCount', '中途覚醒'],
  ['remPercentage', 'REM'],
  ['restlessness', '寝返り'],
  ['lightPercentage', '浅い睡眠'],
  ['deepPercentage', '深い睡眠'],
])
